module.exports = __webpack_public_path__ + "static/media/landscape.07309f59.jpeg";